<template>
  <v-fade-transition hide-on-leave>
    <v-layout column class="overflow-y-hidden">
      <nx-bag-loading-bar :value="loading"></nx-bag-loading-bar>

      <template v-if="current">
        <nx-bag-navigate-back :text="current.name || $t('message.bag.newSearch')"
                              @click="navigateBack"></nx-bag-navigate-back>
        <nx-bag-content-list @load="loading = $event"
                             @click:item="handleContentClick"
                             :filters="searchFilters"
                             :sort="searchSort"
                             class="nx-bag__container">
        </nx-bag-content-list>
        <nx-bag-search-persist-button v-if="currentSearchIsTemporal"
                                      :search="current"
                                      @created="navigateTo">
        </nx-bag-search-persist-button>
      </template>

      <template v-else>
        <nx-bag-search-list @load="loading = $event"
                              @click="navigateTo"
                              :searches="savedSearches"
                              class="nx-bag__container">
        </nx-bag-search-list>
        <nx-bag-search-create-button v-if="!loading"
                                     @created="navigateTo">
        </nx-bag-search-create-button>
      </template>

    </v-layout>
  </v-fade-transition>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { mapState, mapGetters } from 'vuex';
import NxBagNavigateBack from './components/common/BagNavigateBack';
import NxBagContentList from './components/content/BagContentList';
import NxBagSearchList from './components/search/BagSearchList';
import NxBagLoadingBar from './components/common/BagLoadingBar';
import NxBagSearchCreateButton from './components/search/BagSearchCreateButton';
import NxBagSearchPersistButton from './components/search/BagSearchPersistButton';

export default {
  components: {
    NxBagNavigateBack,
    NxBagContentList,
    NxBagSearchList,
    NxBagLoadingBar,
    NxBagSearchCreateButton,
    NxBagSearchPersistButton,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('bag/searches', [
      'current',
    ]),
    ...mapGetters('bag/searches', [
      'savedSearches',
    ]),
    currentSearchIsTemporal() {
      return !this.current || !this.current.name;
    },
    searchFilters() {
      if (!this.current) {
        return {};
      }
      const filters = this.current.filters || {};
      if (isEmpty(filters)) {
        return {};
      }
      return filters;
    },
    searchSort() {
      if (!this.current) {
        return null;
      }
      return this.current.sort || null;
    },
  },
  methods: {
    navigateTo(search) {
      this.$store.dispatch('bag/searches/NAVIGATE_TO', search);
    },
    navigateBack() {
      this.$store.dispatch('bag/searches/NAVIGATE_TO', null);
    },
    handleContentClick(content) {
      this.$store.dispatch('bag/ITEM_SELECTED', content);
    },
    refreshSearches() {
      this.$store.dispatch('bag/searches/REFRESH');
    },
  },
};
</script>
